<!-- manage-response-assign-popup.component.html -->

<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [dismissableMask]="false"
  styleClass="assign-modal-container"
  (onHide)="close()"
  [draggable]="false"
  [resizable]="false"
  [closable]="false"
>
  <ng-template pTemplate="header">
    <div class="modal-header">
      <h2 class="modal-title">Assign</h2>
      <button class="close-button" (click)="close()">
        <i class="pi pi-times"></i>
      </button>
    </div>
  </ng-template>

  <div class="modal-body">
    <h3 class="assign-assessment-title">Assign Assessment</h3>

    <form [formGroup]="assignForm" autocomplete="off">
      <div class="form-group">
        <label for="searchUser"
          >Search User <span class="required">*</span></label
        >
        <p-dropdown
          #userDropdown
          [options]="userOptions"
          optionLabel="name"
          [filter]="true"
          [appendTo]="'body'"
          formControlName="searchUser"
          placeholder="Select User"
          (onFilter)="onUserFilter($event)"
        ></p-dropdown>
      </div>
      <!-- You might add a list of search results here later -->
    </form>
  </div>

  <ng-template pTemplate="footer">
    <div class="footer-buttons">
      <button
        pButton
        type="button"
        label="Cancel"
        class="p-button-secondary"
        (click)="close()"
      ></button>
      <button
        pButton
        type="button"
        label="Assign"
        class="p-button-warning"
        (click)="assignAssessment()"
      ></button>
    </div>
  </ng-template>
</p-dialog>
